export default __webpack_public_path__ + "static/media/Slide_SaleKit2024-03.0ea35bed.png";